import EneasSVG from '@/assets/svg/EneasSVG';
import NordelSVG from '@/assets/svg/NordelSVG';
import VeniSVG from '@/assets/svg/VeniSVG';
import { Image } from '@/lib/wrappers/nextjs';
import { useTranslations } from 'next-intl';
import { getTranslations } from 'next-intl/server';

export const MicrosoftLogo = () => {
  const t = useTranslations('LoginPage.alts');
  return (
    <Image
      className="size-5"
      src="/microsoft-logo.png"
      alt={t('microsoft')}
      height={100}
      width={100}
    />
  );
};

export const EneasLogo = async () => {
  const t = await getTranslations('LoginPage.alts');
  return (
    <EneasSVG
      aria-description={t('eneas')}
      height={31}
      width={200}
      className="fill-veni-green-900"
      fill="black"
    />
  );
};

export const NordelLogo = async () => {
  const t = await getTranslations('LoginPage.alts');
  return (
    <NordelSVG
      aria-description={t('nordel')}
      height={31}
      width={200}
      className="fill-veni-green-900"
      fill="black"
    />
  );
};

export const VeniLogo = async () => {
  const t = await getTranslations('LoginPage.alts');
  return (
    <VeniSVG
      aria-description={t('veni')}
      height={31}
      width={200}
      className="fill-veni-green-900"
      fill="black"
    />
  );
};
